module.exports = __webpack_public_path__ + "static/media/checkbox_small_unchecked.c24a08ed.svg";